import React, {Component, Fragment} from 'react';
import OverviewScreenContainer from '../../containers/screens/OverviewScreenContainer';
import TranslationScreenContainer from '../../containers/screens/TranslationScreenContainer';
import SupporterListScreenContainer from '../../containers/screens/SupporterListScreenContainer';
import SupporterScreenContainer from '../../containers/screens/SupporterScreenContainer';
import QueueListScreenContainer from '../../containers/screens/QueueListScreenContainer';
import LocationGroupsScreenContainer from '../../containers/screens/LocationGroupsScreenContainer';
import RoutesScreenContainer from '../../containers/screens/RoutesScreenContainer';
import ProfileScreen from '../screens/ProfileScreen';
import BatchActionsScreenContainer from '../../containers/screens/BatchActionsScreenContainer';
import Schedule from '../../app/schedule';
import ShiftListsScreenContainer from '../../containers/screens/ShiftListsScreenContainer';
import AddLocationDialogContainer from '../../containers/dialogs/AddLocationDialogContainer';
import UserManagementScreenContainer from '../../containers/screens/UserManagementScreenContainer';
import CashRegisterScreenContainer from '../../containers/screens/CashRegisterScreenContainer';
import TabletScreenContainer from '../../containers/screens/TabletScreenContainer';
import ApplicationScreen from '../screens/ApplicationScreen';
import {HashRouter as Router, Switch, Route} from 'react-router-dom';
import history from '../../history';
import SupporterByBft from "../../app/supporter/bft";
import Logbook from "../../app/logbook";
import StatusScreen from "../../app/statusScreen";
import TopBar from "../navigation/TopBar";
import NavbarLeft from "../navigation/NavbarLeft";
import ProjectManagement from "../../app/projectManagement";
import ProjectStats from "../../app/projectStats";
import Companies from "../../app/companies";
import Company from "../../app/company";

class MainPage extends Component {
    constructor(props) {
        super(props);

        this.alertScan = this.alertScan.bind(this);

        this.cur_barcode = "";
        this.cur_barcode_date = 0;
        this.barcode_input_time = 2000;
        this.last_barcode = "";
        this.last_barcode_data = null;
    }

    alertScan(ean) {
        this.props.getTicket(ean);
        history.push("/cashRegister/" + ean);
    }

    componentDidMount() {
        let self = this;
        let re_barcode = /^[0-9]{13}$/;
        let re_digit = /^[0-9]$/;

        window.onkeyup = function(e) {
            let cur_ts = new Date().getTime() - self.cur_barcode_date;
            if(cur_ts > self.barcode_input_time){
                self.cur_barcode = "";
                self.cur_barcode_date = new Date().getTime();
                self.last_barcode = "";
                self.last_barcode_data = null;
                self.last_barcode = "";
                self.last_barcode_data = null;
            }

            // If enter check if is barcode
            if(e.keyCode === 13){
                let arry = re_barcode.exec(self.cur_barcode);
                self.cur_barcode = "";

                if(arry !== null){
                    self.alertScan(arry[0]);
                    return;
                }
                else if(self.last_barcode_data !== null){
                    self.alertScan(null);
                }
            }

            // Add digit
            let arry = re_digit.exec(e.key);
            if(arry !== null){
                self.cur_barcode += arry[0];
            }
        }
    }

    render() {
        return (
            <div className="MainPage">
                <Router>
                    <Switch>
                        <Route path="/status" component={StatusScreen}/>
                        <Route render={() => (
                            <Fragment>
                                <NavbarLeft/>
                                <div id="page-wrapper">
                                    <TopBar/>
                                    <Switch>
                                        <Route path="/supporter/bft/:token?" component={SupporterByBft}/>
                                        <Route path="/supporter/:id" render={(props) => (
                                            <SupporterScreenContainer key={props.match.params.id} {...props}/>
                                        )}/>
                                        <Route path="/supporter" component={SupporterListScreenContainer}/>
                                        {this.props.roles.find((role) => (role === 'ROLE_ADMIN')) ? (
                                          <Route path="/application/:supporterProjectId?"
                                                 component={ApplicationScreen}/>
                                        ) : null}
                                        <Route path="/schedule" component={Schedule}/>
                                        <Route path="/shiftLists" component={ShiftListsScreenContainer}/>
                                        <Route path="/locations" component={LocationGroupsScreenContainer}/>
                                        <Route path="/tablet" component={TabletScreenContainer}/>
                                        <Route path="/routes" component={RoutesScreenContainer}/>
                                        {this.props.roles.find((role) => (role === 'ROLE_ADMIN')) ? (
                                            <Route path="/translation" component={TranslationScreenContainer}/>
                                        ) : null}
                                        {this.props.roles.find((role) => (role === 'ROLE_ADMIN')) ? (
                                            <Route path="/userManagement" component={UserManagementScreenContainer}/>
                                        ) : null}
                                        {this.props.roles.find((role) => (role === 'ROLE_ADMIN')) ? (
                                          <Route path="/queue" component={QueueListScreenContainer}/>
                                        ) : null}
                                        <Route path="/profile" component={ProfileScreen}/>
                                        <Route path="/logbook" component={Logbook}/>
                                        <Route path="/cashRegister/:ean?" component={CashRegisterScreenContainer}/>
                                        {this.props.roles.find((role) => (role === 'ROLE_ADMIN')) ? (
                                            <Route path="/batch" component={BatchActionsScreenContainer}/>
                                        ) : null}
                                        {this.props.roles.find((role) => (role === 'ROLE_ADMIN')) ? (
                                            <Route path="/projectManagement" component={ProjectManagement}/>
                                        ) : null}
                                        {this.props.roles.find((role) => (role === 'ROLE_ADMIN')) ? (
                                            <Route path="/projectStats" component={ProjectStats}/>
                                        ) : null}
                                        {this.props.roles.find((role) => (role === 'ROLE_ADMIN')) ? (
                                            <Route path="/companies" component={Companies}/>
                                        ) : null}
                                        {this.props.roles.find((role) => (role === 'ROLE_ADMIN')) ? (
                                            <Route path="/company/:id" render={(props) => (
                                                <Company key={props.match.params.id} {...props}/>
                                            )}/>
                                        ) : null}
                                        <Route path="/" component={OverviewScreenContainer}/>
                                    </Switch>
                                </div>
                                {(this.props.addLocationDialogOpen) ? (
                                    <AddLocationDialogContainer/>
                                ) : null}
                            </Fragment>
                        )}/>
                    </Switch>
                </Router>
            </div>
        )
    }
}

export default MainPage;
